export default {
  data () {
    return {
      loadingCounter: 0,
      loadingErrors: null
    }
  },
  computed: {
    isLoading () {
      return this.loadingCounter > 0
    }
  },
  methods: {
    loadingStart () {
      this.loadingCounter += 1
    },
    loadingEnd () {
      setTimeout(() => {
        this.loadingCounter -= 1
      }, 250)
    },
    loadingError (error) {
      if (error.isNetworkError()) {
        this.loadingErrors = ['Oops! There was a problem with your network connection. Please try again in a moment']
        return
      }
      if (error.isValidation()) {
        this.loadingErrors = error.validation
        return
      }
      this.loadingErrors = ['Oops! We are sorry but you encountered unhandled error type!']
    },
    loadingErrorsReset () {
      this.loadingErrors = null
    }
  }
}
